/*
 * Copyright 2025 Intuition Robotics ltd
 */
import {config} from "../config";

export const loginValidate = async (): Promise<boolean> => {
    const urlSearch = new URLSearchParams(window.location.search);
    const jwt = urlSearch.get('JWT') || sessionStorage.getItem("jwt");
    if (jwt) {
        sessionStorage.setItem("jwt", jwt);
    }
    const validateUrl = '/v1/owner-admin/validate';
    const validateHeaders = {Authorization: `Bearer ${jwt}`}

    try {
        const response = await fetch(`${config.messagingUrl}${validateUrl}`, {
            method: 'GET',
            headers: validateHeaders
        })

        if (!response.ok) {
            console.error(`HTTP error! Status: ${response.status}`);
            return false;
        }

        return true;
    } catch (error) {
        console.error('Error: ', error);
        return false;
    }
};